"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'question.type.text': '文本',
    'question.type.textarea': '文本区域',
    'question.type.select': '选择',
    'question.type.radio': '单选',
    'question.type.checkbox': '复选框',
    'question.type.number': '数字',
    'question.type.email': '邮箱',
    'question.type.url': 'URL',
    'question.type.date': '日期',
};
